<template>
  <LazyUiDialog
    class="media-gallery-fullscreen"
    name="media-gallery"
    dialog-type="fullscreen"
  >
    <div class="media-gallery-fullscreen__container">
      <button
        class="media-gallery-fullscreen__close"
        @click="closeFullscreen"
      >
        <IconClose class="icon--close" />
      </button>

      <UiMediaGalleryThumbs class="media-gallery-fullscreen__thumbs" />

      <UiMediaGalleryFullscreenMain class="media-gallery-fullscreen__main" />

      <div class="media-gallery-fullscreen__controls">
        <UiMediaGalleryDots class="media-gallery-fullscreen__dots" />

        <UiMediaGalleryPrevNext class="media-gallery-fullscreen__navigation" />
      </div>
    </div>
  </LazyUiDialog>
</template>

<script lang="ts" setup>
const { close: closeFullscreen } = useUiDialog('media-gallery')
</script>

<style src="~layers/app/components/Ui/MediaGallery/Fullscreen.css" />
